// Import React Components
import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";

// Import State Management
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {licensePermission, rolePermission, activeSideBarMenu} from "../../../../recoil-store/recoil-state";

// Import Additional Packages
import clsx from "clsx";

// Import Media Tools
import DashboardIcon from "../../../../assets/icons/DashboardIcon";
import Monitoring from "../../../../assets/icons/Monitoring";
import Alert from "../../../../assets/icons/Alert";
import LibraryStore from "../../../../assets/icons/LibraryStore";
import Libraries from "../../../../assets/icons/Libraries";
import ManagementIcon from "../../../../assets/icons/ManagementIcon";
import SettingsIcon from "../../../../assets/icons/SettingsIcon";
import MyEnvironment from "../../../../assets/icons/MyEnvironment";
import Notification from "../../../../assets/icons/Notification";
import Store from "../../../../assets/icons/Store";
import CreateAutom from "../../../../assets/icons/CreateAutom";
import WebhookAPI from "../../../../assets/icons/WebhookAPI";
import Vault from "../../../../assets/icons/Vault";
import UserManagement from "../../../../assets/icons/UserManagement";
import Orchestrator from "../../../../assets/icons/Orchestrator";
import Automs from "../../../../assets/icons/Automs";
import AutomStore from "../../../../assets/icons/AutomStore";
import Queue from "../../../../assets/icons/Queue";
import MyMates from "../../../../assets/icons/MyMates";
import AlertManagement from "../../../../assets/icons/AlertManagement";
import Approvements from "../../../../assets/icons/Approvements";

import {ReactComponent as AiIcon} from "../../../../assets/icons/AiIcon.svg";

// Import Data
import {SIDE_NAV_BAR_BOTTOM_ITEMS, SIDE_NAV_BAR_TOP_ITEMS} from "../../../../services/MockData";

// Import Helper
import {hasSubItemsPermission} from "../../../../helpers/helper";

// Import Components
import Language from "../../../component/Language/language";
import Help from "../../../component/Help/HelpSection";
import Profile from "../../../component/Profile/Profile";

// Import CSS Files
import './menuItem.css';

// Import Material-UI
import {Fade, Tooltip} from "@material-ui/core";
import {ExpandLess, ExpandMore} from "@material-ui/icons";


const SIDEBAR_ICON_SET = {
    Store: <Store/>,
    AutomStore: <AutomStore/>,
    Dashboard: <DashboardIcon/>,
    MyEnvironment: <MyEnvironment/>,
    Management: <ManagementIcon/>,
    CreateAutom: <CreateAutom/>,
    Settings: <SettingsIcon/>,
    Notification: <Notification/>,
    Monitoring: <Monitoring/>,
    Alert: <Alert/>,
    LibraryStore: <LibraryStore/>,
    Automs: <Automs/>,
    Vault: <Vault/>,
    Orchestrator: <Orchestrator/>,
    UserManagement: <UserManagement/>,
    WebhookApi: <WebhookAPI/>,
    Libraries: <Libraries/>,
    AlertManagement: <AlertManagement/>,
    MyMates: <MyMates/>,
    Queue: <Queue/>,
    Approvements: <Approvements/>,
    AiIcon: <AiIcon style={{color: "#4F6E90"}}/>,
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        zIndex: "1205",
    },
    logo: {width: 180},
    hide: {display: "none"},
    customTooltip: {
        // I used the rgba color for the standard "secondary" color
        backgroundColor: 'rgba(11, 41, 73, 0.89);',
        height: 38,
        top: -8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ffffff",
        fontSize: 12,
        left: -4
    },
    customArrow: {
        color: 'rgba(11, 41, 73, 0.89);',
    },
    customSubTooltip: {
        // I used the rgba color for the standard "secondary" color
        backgroundColor: 'rgba(11, 41, 73, 0.89);',
        height: 38,
        top: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ffffff",
        fontSize: 12,
        left: -4
    },
    customSubArrow: {
        color: 'rgba(11, 41, 73, 0.89);',
    },
}));

export default function MenuItem({sideBarOpen, setSideBarOpen, setToggleDrawer, toggleDrawer, asm}) {
    const navigate = useNavigate();
    const classes = useStyles();
    const permissions = useRecoilValue(rolePermission)
    const license = useRecoilValue(licensePermission);
    const [asmTemp, setAsmTemp] = useState({});
    const [isSubList, setIsSubList] = useState("");
    const [openList, setOpenList] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        if (asm) setAsmTemp(JSON.parse(JSON.stringify(asm)));
    }, []);

    const openSideBarEachPage = (name, order) => {
        if (isSubList !== name) {
            setOpenList(false);
            setOpenList(name)
        }
        setToggleDrawer(true);
        setSideBarOpen(true);
        setToggleDrawer(true);
    };

    const handleListClick = (name, e) => {
        if (openList === name) {
            setOpenList(false);
        } else {
            setOpenList(name);
            setIsSubList(name);
            setToggleDrawer(true);
            if (!sideBarOpen) {
                setSideBarOpen(!sideBarOpen);
            }
        }
    };

    const handleListItemClick = (event, parentOrder, childOrder = 0, thirdLevel) => {
        asmTemp.parent = parentOrder;
        if (childOrder)
            asmTemp.child = childOrder;
        if (thirdLevel) {
            asmTemp.thirdChild = thirdLevel[0].order;
        }
        updateASMState(asmTemp);
    };

    const navigateUser = (to, order) => {
        if (to) {
            updateASMState({parent: order, child: 0});
            navigate(to);
        }
    }

    const updateASMState = (asmState) => {
        setAsmTemp(asmState)
    }

    return (
        <>
            <div className="menu-item-list">
                <div className={`menu-item-row ${sideBarOpen ? 'w-100' : ''}`}>
                    {SIDE_NAV_BAR_TOP_ITEMS.map(
                        ({label, description, name, Icon, to, subItems, tag, order, addOn, ...rest}, index) => (
                            hasSubItemsPermission(
                                permissions?.data,
                                tag,
                                subItems
                            ) && (
                                sideBarOpen ? (
                                    <div
                                        to={to}
                                        className="link cover-list"
                                        onClick={() => openSideBarEachPage(name, order)}>
                                        <div
                                            className={`list-has-subitem expanded ${subItems ? "" : "hover-me "} ${!subItems && asmTemp?.parent === order ? 'listitem-active' : ''}`}
                                            onClick={(e) => {
                                                handleListClick(name, e);
                                            }}>
                                            <div key={order}
                                                 className={`menu-item  ${subItems ? "hidden " : ""}`}
                                                 onClick={(event) =>
                                                     handleListItemClick(
                                                         event,
                                                         order
                                                     )}>
                                                <span className={`sidebar-item-icon`}>
                                                    {SIDEBAR_ICON_SET[Icon]}
                                                </span>
                                            </div>
                                            <Fade in={sideBarOpen} timeout={{enter: 500, exit: 100}}>
                                                <div style={{width: "100%"}}
                                                     className={clsx({
                                                         [classes.hide]: !sideBarOpen,
                                                     })}>
                                                  <span className={`list-item-text ${subItems ? "has-sub" : ""}`}
                                                        onClick={() => navigateUser(to, order)}>
                                                        {t(label)}
                                                      {addOn && (
                                                          <span
                                                              className="addon-chip">Add-On</span>
                                                      )}
                                                  </span>
                                                    <div
                                                        className={`list-item-description ${asmTemp?.parent === order || openList === name || !subItems ? "hidden" : ""}`}>
                                                        {t(description)}
                                                    </div>
                                                    <div
                                                        className={`sub-list-container ${asmTemp?.parent === order || openList === name ? "show-me" : "hide-me"}`}>
                                                        {subItems && subItems.map(({
                                                                                       name,
                                                                                       to,
                                                                                       label,
                                                                                       Icon,
                                                                                       tag,
                                                                                       addOn,
                                                                                       ...rest
                                                                                   }, index) => (
                                                            <div key={subItems[index].order}>
                                                                {(!tag ||
                                                                    permissions?.data?.includes(tag)) &&
                                                                (tag === "CUSTOMAUTOMS_VIEW"
                                                                    ? license?.data?.flow_designer
                                                                    : true) && (
                                                                    <Link to={rest?.disabled ? '#' : to ? to : "#"}
                                                                          className="link">
                                                                        <div
                                                                            className={`list-sub-item  ${asmTemp?.child === subItems[index].order ?
                                                                                "listitem-active" : ""
                                                                            }`}
                                                                            onClick={(event) =>
                                                                                handleListItemClick(
                                                                                    event,
                                                                                    order,
                                                                                    subItems[index].order,
                                                                                    subItems[index].thirdLevelItems
                                                                                )
                                                                            }
                                                                        >
                                                                        <span className={`sidebar-item-icon`}>
                                                                            {SIDEBAR_ICON_SET[Icon]}
                                                                        </span>
                                                                            <span
                                                                                className="subitem-text"
                                                                                style={{color: "rgba(144, 185, 231, 0.55)"}}>
                                                                                {t(label)}
                                                                                {addOn && (
                                                                                    <span
                                                                                        className="addon-chip">Add-On</span>
                                                                                )}
                                                                        </span>
                                                                        </div>
                                                                    </Link>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </Fade>
                                            {subItems && (
                                                asmTemp?.parent === order || openList === name ? (
                                                    <Fade in={sideBarOpen} timeout={{enter: 500, exit: 100}}>
                                                        <ExpandLess
                                                            className={clsx({
                                                                [classes.hide]: !sideBarOpen,
                                                            })}
                                                            style={{
                                                                color: "#dedede",
                                                                width: 14,
                                                                position: "absolute",
                                                                right: 10,
                                                                top: 5
                                                            }}
                                                        />
                                                    </Fade>
                                                ) : (
                                                    <Fade
                                                        in={toggleDrawer}
                                                        timeout={{enter: 500, exit: 100}}>
                                                        <ExpandMore
                                                            className={clsx({
                                                                [classes.hide]: !toggleDrawer,
                                                            })}
                                                            style={{
                                                                color: "#dedede",
                                                                width: 14,
                                                                position: "absolute",
                                                                right: 10,
                                                                top: 5
                                                            }}
                                                        />
                                                    </Fade>
                                                )
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        to={to}
                                        className="link cover-list-collapsed"
                                        onClick={() => openSideBarEachPage(name, order)}>

                                        <Tooltip title={t(label)} placement="right" classes={{
                                            tooltip: classes.customSubTooltip,
                                            arrow: classes.customSubArrow
                                        }} arrow>
                                            <div key={order}
                                                 className={`menu-item ${asmTemp?.parent === order ? 'listitem-active' : ''}`}
                                                 onClick={(event) =>
                                                     handleListItemClick(
                                                         event,
                                                         order
                                                     )}>
                                            <span className="sidebar-item-icon">
                                                {SIDEBAR_ICON_SET[Icon]}
                                            </span>
                                            </div>
                                        </Tooltip>
                                    </div>
                                )
                            )
                        )
                    )}
                </div>
                <div className={`menu-item-row ${sideBarOpen ? 'w-100' : ''}`}>
                    {SIDE_NAV_BAR_BOTTOM_ITEMS.map(
                        ({
                             label,
                             description,
                             name,
                             Icon,
                             to,
                             subItems,
                             tag,
                             order,
                             addOn,
                             additionalClass,
                             ...rest
                         }, index) => (
                            sideBarOpen ? (
                                <div
                                    to={to}
                                    className="link cover-list"
                                    onClick={subItems ? () => openSideBarEachPage(name, order) : () => navigateUser(to, order)}>
                                    <div
                                        className={`list-has-subitem expanded ${subItems ? "" : "hover-me"} ${!subItems && asmTemp?.parent === order ? 'listitem-active' : ''}`}
                                        onClick={(e) => {
                                            handleListClick(name, e);
                                        }}>
                                        <div key={order}
                                             className={`menu-item ${subItems ? "hidden " : ""} ${(asmTemp?.parent) === order ? 'listitem-active' : ''}`}
                                             onClick={(event) =>
                                                 handleListItemClick(
                                                     event,
                                                     order
                                                 )}>
                                            <span
                                                className={`sidebar-item-icon ${additionalClass && additionalClass.join(' ')}`}>
                                                {SIDEBAR_ICON_SET[Icon]}
                                            </span>
                                        </div>
                                        <Fade in={sideBarOpen} timeout={{enter: 500, exit: 100}}>
                                            <div style={{width: "100%"}}
                                                 className={clsx({
                                                     [classes.hide]: !sideBarOpen,
                                                 })}>
                                                  <span className={`list-item-text expanded`}>
                                                    {t(label)}
                                                      {addOn && (
                                                          <span
                                                              className="addon-chip">Add-On</span>
                                                      )}
                                                  </span>
                                                <div
                                                    className={`list-item-description ${asmTemp?.parent === order || openList === name || !subItems ? "hidden" : ""}`}>
                                                    {t(description)}
                                                </div>
                                                {subItems && subItems.map(({
                                                                               name,
                                                                               to,
                                                                               label,
                                                                               Icon,
                                                                               tag,
                                                                               addOn,
                                                                               ...rest
                                                                           }, index) => (
                                                    <div key={subItems[index].order}>
                                                        {(!tag ||
                                                            permissions?.data?.includes(tag)) &&
                                                        (tag === "CUSTOMAUTOMS_VIEW"
                                                            ? license?.data?.flow_designer
                                                            : true) && (
                                                            <Link to={rest?.disabled ? '#' : to}
                                                                  className="link">
                                                                <div
                                                                    className={`list-sub-item  ${asmTemp?.child === subItems[index].order ?
                                                                        "listitem-active" : ""
                                                                    }`}
                                                                    onClick={(event) =>
                                                                        handleListItemClick(
                                                                            event,
                                                                            order,
                                                                            subItems[index].order
                                                                        )
                                                                    }
                                                                >
                                                                        <span className={`sidebar-item-icon`}>
                                                                            {SIDEBAR_ICON_SET[Icon]}
                                                                        </span>
                                                                    <span
                                                                        className="subitem-text"
                                                                        style={{color: "rgba(144, 185, 231, 0.55)"}}>
                                                                          {t(label)}
                                                                        {addOn && (
                                                                            <span
                                                                                className="addon-chip">Add-On</span>
                                                                        )}
                                                                        </span>
                                                                </div>
                                                            </Link>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </Fade>
                                        {subItems && (
                                            asmTemp?.parent === order || openList === name ? (
                                                <Fade in={sideBarOpen} timeout={{enter: 500, exit: 100}}>
                                                    <ExpandLess
                                                        className={clsx({
                                                            [classes.hide]: !sideBarOpen,
                                                        })}
                                                        style={{
                                                            color: "#dedede",
                                                            width: 14,
                                                            position: "absolute",
                                                            right: 10,
                                                            top: 5
                                                        }}
                                                    />
                                                </Fade>
                                            ) : (
                                                <Fade
                                                    in={toggleDrawer}
                                                    timeout={{enter: 500, exit: 100}}>
                                                    <ExpandMore
                                                        className={clsx({
                                                            [classes.hide]: !toggleDrawer,
                                                        })}
                                                        style={{
                                                            color: "#dedede",
                                                            width: 14,
                                                            position: "absolute",
                                                            right: 10,
                                                            top: 5
                                                        }}
                                                    />
                                                </Fade>
                                            )
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div
                                    to={to}
                                    className="link cover-list-collapsed"
                                    onClick={() => openSideBarEachPage(name, order)}>

                                    <Tooltip title={t(label)} placement="right" classes={{
                                        tooltip: classes.customSubTooltip,
                                        arrow: classes.customSubArrow
                                    }} arrow>
                                        <div key={order}
                                             className={`menu-item ${asmTemp?.parent === order ? 'listitem-active' : ''}`}
                                             onClick={(event) =>
                                                 handleListItemClick(
                                                     event,
                                                     order
                                                 )}>
                                            <span
                                                className={`sidebar-item-icon ${additionalClass && additionalClass.join(' ')}`}>
                                                {SIDEBAR_ICON_SET[Icon]}
                                            </span>
                                        </div>
                                    </Tooltip>
                                </div>
                            )
                        )
                    )}
                    <Help sideBarOpen={sideBarOpen}/>
                    <Language sideBarOpen={sideBarOpen}/>
                    <Profile sideBarOpen={sideBarOpen}/>
                </div>
            </div>
        </>
    )
}
